<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{ path: '/' }" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item active">Пользователи</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<div class="float-end d-flex">
				<router-link :to="{ path: '/users/groups' }" class="btn btn-secondary d-flex align-items-center me-2">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
						<path d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
					</svg>
					<span class="d-none d-md-inline-block ms-2">Группы пользователей</span>
				</router-link>
				<router-link :to="{ path: '/users/add' }" class="btn btn-primary d-flex align-items-center">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
						<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
					</svg>
					<span class="d-none d-md-inline-block ms-2">Добавить пользователя</span>
				</router-link>
			</div>
			<h5>Пользователи</h5>
			<div class="text-muted">Управление пользователями</div>
		</div>
		<filter-bar 
			v-model:search="search" 
			v-model:limit="limit" 
			:loading="loading" 
		/>
		<div class="table-responsive">
			<table class="table table-hover table-bordered">
				<thead>
					<tr>
						<th style="width: 38px" class="text-center">Avatar</th>
						<th>Логин</th>
						<th width="25%">Группы</th>
						<th width="25%">Проекты</th>
						<th style="width: 125px" class="text-center">Операции</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in users" :key="user.id">
						<td class="align-middle text-center">
							<image-with-placeholder
								:src="getAvatar(user)"
								class="mw-100 ratio ratio-1x1 rounded"
								height="100%"
								skeleton="shimmer"
								alt="ava"
							/>
						</td>
						<td class="align-middle">
							<code>{{ user.login }}</code>
							<span
								class="badge bg-danger ms-1"
								title="Админ"
								v-tippy="{ placement: 'top' }"
								v-if="user.is_admin"
							>A</span>
							<span
								class="badge bg-danger ms-1"
								title="Заблокирован"
								v-tippy="{ placement: 'top' }"
								v-if="user.is_blocked"
							>B</span>
						</td>
						<td class="align-middle">
							<span class="badge text-bg-primary font-monospace me-1">@all</span>
							<router-link
								:to="{ path: '/users/groups/' + group.id }"
								class="badge text-bg-dark text-decoration-none font-monospace me-1"
								v-for="group in user.groups" :key="group.id"
							>@{{ group.name }}</router-link>
						</td>
						<td class="align-middle">
							<router-link
								:to="{ path: '/projects/' + project.id }"
								class="badge text-bg-warning text-decoration-none font-monospace me-1"
								v-for="project in user.projects" :key="project.id"
								v-tippy="{ placement: 'top' }"
								:title="project.name"
							>{{ project.apiname }}</router-link>
						</td>
						<td class="align-middle">
							<div
								class="d-grid gap-2 d-md-flex align-items-center justify-content-md-center"
							>
								<router-link
									:to="{ path: '/users/' + user.id }"
									class="btn btn-primary d-flex align-items-center justify-content-center"
									:disabled="user.loading"
									title="Изменить"
									v-tippy="{ placement: 'top' }"
								>
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
									</svg>
								</router-link>
								<button
									type="button"
									class="btn btn-danger d-flex align-items-center justify-content-center"
									:disabled="user.loading"
									title="Удалить"
									v-tippy="{ placement: 'top' }"
									@click="deleteUser(user.id)"
								>
									<span v-if="user.loading" class="spinner-border spinner-border-sm" style="width: 24px; height: 24px;"></span>
									<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
									</svg>
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">
				Всего пользователей: {{ users_count }}
			</div>
			<nav aria-label="Page navigation">
				<pagination 
					v-model="page" 
					:total="users_count" 
					:limit="limit" 
					:loading="loading"
					@change="loadData"
				/>
			</nav>
		</div>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from "@/lib";
import { useMeta } from "vue-meta";
import { useModal } from "vue-final-modal";

import FilterBar from '@/components/FilterBar.vue';
import Pagination from '@/components/Pagination.vue';
import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup() {
		useMeta({ title: "Пользователи | SKV" });
	},
	data: () => ({
		users: [],
		users_count: 0,

		search: "",
		page: 1,
		limit: 25,
		loading: true,
		debounceTimeout: null,
	}),
	watch: {
		// Если пользователь нажал "Назад" или изменил URL, подгружаем данные заново
		'$route.query': {
			handler(newQuery) {
				this.search = newQuery.search || "";
				this.page = parseInt(newQuery.page) || 1;
				// Вызываем загрузку без push в роутер (чтобы не зациклиться)
				this.fetchUsers(); 
			},
			immediate: true,
		},
		search(newVal) {
			this.page = 1; // При поиске всегда сбрасываем на 1 страницу
			this.debouncedSearch();
		},
		limit(newVal) {
			this.page = 1;
			this.fetchUsers();
		},
	},
	methods: {
		getAvatar(user) {
			const avatar = user?.avatar;
			if (!avatar) return "/files/avatar/default.svg";
			return `/files/avatar/${avatar}`;
		},

		async fetchUsers() {
			this.loading = true;
			const params = {
				search: this.search,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetUsers(params);
			if (ret.success) {
				this.users = ret.list.map(user => ({
					...user,
					loading: false,
				}));
				this.users_count = ret.count;
			} else {
				this.$toast.error(ret.message);
			}
			this.loading = false;
		},
		debouncedSearch() {
			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(() => {
				this.loadData();
			}, 500);
		},
		async loadData() {
			// Мы просто меняем URL, а Watcher сам увидит это и вызовет fetchUsers
			await this.$router.push({
				query: { 
					...this.$route.query, 
					search: this.search || undefined, 
					page: this.page,
				},
			}).catch(() => {});
		},
		
		async deleteUser(id) {
			const user = this.users.find(g => g.id === id);
			if (!user) return;
			
			useModal({
				component: BootstrapConfirmModal,
				attrs: {
					title: "Удаление пользователя",
					centered: true,
					confirmText: "Удалить пользователя",
					confirmColor: "danger",
					onConfirm: async () => {
						user.loading = true;
						try {
							const result = await this.appModel.doDeleteUser(id);
							if (result.success) {
								this.fetchUsers();
							} else {
								this.$toast.error(result.message);
							}
						} finally {
							user.loading = false;
						}
					},
				},
				slots: {
					default: `Вы уверены, что хотите безвозвратно удалить пользователя "${user.login}"?`,
				},
			}).open();
		},
	},
	components: {
		FilterBar,
		Pagination,
		ImageWithPlaceholder,
	}
};
</script>
